import { createApi } from "@reduxjs/toolkit/query/react";
import { PageMeta, PaginatedData, Response, SocialListData } from "../../types";
import { axiosBaseQuery } from "./AxiosBaseQuery";

export interface EnquiresState {
  name: string;
  email?: string;
  phone: string;
  message?: string;
}

export const EnquiresApi = createApi({
  reducerPath: "enquiresAPI",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["EnquiryList", "EnquiryListById"],
  endpoints: (builder) => ({
    enquiryList: builder.query<
      Response<PaginatedData<SocialListData[]>>,
      PageMeta
    >({
      // Getting enquiry query parameters
      query: (pageData: PageMeta) => ({
        url: `/enquires`,
        method: "GET",
        params: {
          limit: pageData.per_page ?? Number(process.env.REACT_APP_PER_PAGE),
          page: pageData.page ?? 1,
          order: pageData.order ?? process.env.REACT_APP_ORDER,
          order_by: pageData.order_by ?? process.env.REACT_APP_ORDER_BY,
          search: pageData.searchText,
          startDate: pageData.startDate ?? "",
          endDate: pageData.endDate ?? "",
        },
      }),
      providesTags: ["EnquiryList"],
    }),

    // Getting enquiry query parameters by ID
    enquiryListById: builder.query<
      Response<SocialListData>,
      string | undefined
    >({
      query: (id: string | undefined) => ({
        url: `/enquires/${id}`,
        method: "GET",
      }),
      providesTags: ["EnquiryListById"],
    }),

    // Creating enquiry mutation
    addEnquiry: builder.mutation<Response<FormData>, FormData>({
      query: (mtuser: FormData) => ({
        url: `/enquires`,
        method: "POST",
        body: mtuser,
      }),
      invalidatesTags: ["EnquiryList"],
    }),

    // Updating Enquires mutation
    editEnquiry: builder.mutation<Response<FormData>, FormData>({
      query: (data: FormData) => ({
        url: `/enquires/${data.get("id")}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["EnquiryList"],
    }),

    deleteEnquires: builder.mutation<
      Response<EnquiresState>,
      string | undefined
    >({
      query: (id: string | undefined) => ({
        url: `/enquires/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EnquiryList"],
    }),

    // Getting enquires query parameters
    getEnquiries: builder.query<Response, void>({
      query: () => ({
        url: `/enquires/get-enquiries`,
        method: "GET",
      }),
      providesTags: ["EnquiryList"],
    }),


    getNewsLetterList: builder.query<Response<PaginatedData<any[]>>, PageMeta>({
      query: (pageData: PageMeta) => ({
        url: `/enquires/get-newsLetter`,
        method: "GET",
        params: {
          limit: pageData.per_page ?? Number(process.env.REACT_APP_PER_PAGE),
          page: pageData.page ?? 1,
          order: pageData.order ?? process.env.REACT_APP_ORDER,
          order_by: pageData.order_by ?? process.env.REACT_APP_ORDER_BY,
        },
      }),
      providesTags: ["EnquiryList"],
    }),


  }),


});
export const {
  useEnquiryListQuery,
  useEnquiryListByIdQuery,
  useAddEnquiryMutation,
  useEditEnquiryMutation,
  useDeleteEnquiresMutation,
  useGetEnquiriesQuery,
  useGetNewsLetterListQuery,
} = EnquiresApi;
